export class TranslationBundle {
  ru?: string;
  en?: string;
  zh?: string;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/models/translation-bundle.model.ts